export const CHANGE_STAGE = 'signup/CHANGE_STAGE';
export const CHANGE_LEVEL = 'signup/CHANGE_LEVEL';
export const CHANGE_ENTITY = 'signup/CHANGE_ENTITY';
export const RESET_STATE = 'signup/RESET_STATE';
export const SIGN_UP_SUCCESS = 'signup/SIGN_UP_SUCCESS';
export const SIGN_UP_FAILED = 'signup/SIGN_UP_FAILED';
export const SIGN_UP_REQUEST = 'signup/SIGN_UP_REQUEST';
export const EXIT_FORM = 'signup/EXIT_FORM';
export const OPEN_EXIT_MODAL = 'signup/OPEN_EXIT_MODAL';
export const CLOSE_EXIT_MODAL = 'signup/CLOSE_EXIT_MODAL';
export const OPEN_PIX_MODAL = 'signup/OPEN_PIX_MODAL';
export const CLOSE_PIX_MODAL = 'signup/CLOSE_PIX_MODAL';
export const UPDATE_ONBOARDING_STATUS = 'signup/UPDATE_ONBOARDING_STATUS';
